"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Zap, TrendingUp, DollarSign } from "lucide-react";
export default function WhyChooseProMarketing() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="bg-dark-background py-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {}
          <div ref={ref1} className={`flex flex-col items-start group transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-[0_4px_16px_rgba(0,0,0,0.3)] ${isVisible1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: isVisible1 ? "0ms" : "0ms",
          transitionProperty: "opacity, transform, box-shadow"
        }}>
            <div className="mb-6 p-4 rounded-lg bg-primary/10 text-primary">
              <Zap className="w-10 h-10" />
            </div>
            <h3 className="text-2xl font-display font-semibold text-foreground-dark mb-4 relative inline-block">Produzioni rapide<span className="absolute left-0 bottom-0 h-0.5 w-0 bg-gradient-to-r from-primary to-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full"></span></h3>
            <p className="text-foreground-dark/80 leading-relaxed">
              Video social pronti in pochi giorni. Realizziamo contenuti dinamici e accattivanti per Instagram, Facebook e TikTok con tempi di consegna rapidissimi.
            </p>
          </div>

          {}
          <div ref={ref2} className={`flex flex-col items-start group transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-[0_4px_16px_rgba(0,0,0,0.3)] ${isVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: isVisible2 ? "200ms" : "0ms",
          transitionProperty: "opacity, transform, box-shadow"
        }}>
            <div className="mb-6 p-4 rounded-lg bg-secondary/10 text-secondary">
              <TrendingUp className="w-10 h-10" />
            </div>
            <h3 className="text-2xl font-display font-semibold text-foreground-dark mb-4 relative inline-block">
              Unisciti al nostro club
              <span className="absolute left-0 bottom-0 h-0.5 w-0 bg-gradient-to-r from-primary to-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full"></span>
            </h3>
            <p className="text-foreground-dark/80 leading-relaxed">
              Ogni video racconta una storia coinvolgente. Entrando a far parte del nostro club potrai amplificare la presenza del tuo brand sui social.
            </p>
          </div>

          {}
          <div ref={ref3} className={`flex flex-col items-start group transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-[0_4px_16px_rgba(0,0,0,0.3)] ${isVisible3 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: isVisible3 ? "400ms" : "0ms",
          transitionProperty: "opacity, transform, box-shadow"
        }}>
            <div className="mb-6 p-4 rounded-lg bg-accent/10 text-accent">
              <DollarSign className="w-10 h-10" />
            </div>
            <h3 className="text-2xl font-display font-semibold text-foreground-dark mb-4 relative inline-block">
              Prezzi Accessibili
              <span className="absolute left-0 bottom-0 h-0.5 w-0 bg-gradient-to-r from-primary to-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full"></span>
            </h3>
            <p className="text-foreground-dark/80 leading-relaxed">
              Qualità professionale senza svuotare il budget. Offriamo soluzioni trasparenti e convenienti, perfette per startup e piccole imprese.
            </p>
          </div>
        </div>
      </div>
    </section>;
}